"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Buttons = require("./Buttons");
Object.keys(_Buttons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Buttons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Buttons[key];
    }
  });
});
var _CopyLinkAndWelcomeMessage = require("./CopyLinkAndWelcomeMessage");
Object.keys(_CopyLinkAndWelcomeMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CopyLinkAndWelcomeMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CopyLinkAndWelcomeMessage[key];
    }
  });
});
var _FeedbackBenefitBanner = require("./FeedbackBenefitBanner");
Object.keys(_FeedbackBenefitBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeedbackBenefitBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeedbackBenefitBanner[key];
    }
  });
});
var _FeedbackBenefitDialog = require("./FeedbackBenefitDialog");
Object.keys(_FeedbackBenefitDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeedbackBenefitDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeedbackBenefitDialog[key];
    }
  });
});
var _FormattedMessage = require("./FormattedMessage");
Object.keys(_FormattedMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormattedMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormattedMessage[key];
    }
  });
});
var _Loading = require("./Loading");
Object.keys(_Loading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Loading[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Loading[key];
    }
  });
});
